export interface IBurgerMenuStoreState {
    isOpen: boolean;
}
export class BurgerMenuStoreState implements IBurgerMenuStoreState {
    isOpen: boolean = false;
    constructor(opt?: any) {
        this.isOpen = opt && opt.isOpen ? opt.isOpen : false; 
    }
}
